import { useState, useRef, useEffect } from 'react';

export const useResizeHandler = () => {
  const [addressesWidth, setAddressesWidth] = useState('40%');
  const [isResizingAddresses, setIsResizingAddresses] = useState(false);
  const addressesContainerRef = useRef<HTMLDivElement>(null);

  const handleAddressesMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsResizingAddresses(true);
  };

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isResizingAddresses || !addressesContainerRef.current) return;

      const containerRect = addressesContainerRef.current.getBoundingClientRect();
      const newWidth = e.clientX - containerRect.left;
      const containerWidth = containerRect.width;

      const minWidth = containerWidth * 0.25;
      const maxWidth = containerWidth * 0.75;

      if (newWidth >= minWidth && newWidth <= maxWidth) {
        const widthPercentage = (newWidth / containerWidth) * 100;
        setAddressesWidth(`${widthPercentage}%`);
      }
    };

    const handleMouseUp = () => {
      setIsResizingAddresses(false);
    };

    if (isResizingAddresses) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizingAddresses]);

  return {
    addressesWidth,
    isResizingAddresses,
    addressesContainerRef,
    handleAddressesMouseDown,
  };
};